import uuid from "uuid-random";
import * as _firebase from "firebase/app";
import "firebase/functions";

const firebase = _firebase.default;

export type Logger = {
  log(msg: string): void;
  warn(msg: string): void;
  error(msg: string): void;
};

export type Storage = {
  getItem<T = void>(key: string): Promise<T | null>;
  setItem<T = void>(key: string, value: T): Promise<T>;
};

export default class {
  private ready: Promise<void>;
  private cachedDeviceId: string | undefined;

  constructor(private logger: Logger, private storage: Storage) {
    this.ready = this.init();
  }

  private async init() {}

  private getDeviceId = async (): Promise<string> => {
    if (this.cachedDeviceId) {
      return this.cachedDeviceId;
    }
    let deviceId = await this.storage.getItem<string>("deviceId");
    if (!deviceId) {
      deviceId = uuid();
      await this.storage.setItem<string>("deviceId", deviceId);
    }
    this.cachedDeviceId = deviceId;
    return deviceId;
  };

  functions = {
    shop: {}
  };

  callAPI = async (endpoint: string, params?: any): Promise<any> => {
    await this.ready;
    this.logger.log(
      `Calling Firebase API endpoint ${endpoint} with params ${JSON.stringify(
        params,
        null,
        2
      )}`
    );
    const deviceId = await this.getDeviceId();
    const f = firebase.functions().httpsCallable("logic");
    const data = {
      endpoint,
      params: { ...params, deviceId }
    };
    for (const key in data.params) {
      if (data.params[key] && data.params[key] instanceof Date) {
        try {
          (data.params[key] as Date).toISOString();
        } catch (e2) {
          console.log("Deleting date param.");
          delete data.params[key];
        }
      }
    }
    try {
      const result = await f(data);
      this.logger.log(
        `Got endpoint ${endpoint} result.` // ${JSON.stringify(result, null, 2)}`
      );
      return result ? result.data : null;
    } catch (e) {
      this.logger.error(`Call to endpoint ${endpoint} failed`);
      this.logger.warn(e as string);
    }
  };
}
